import qs from 'querystring'
 

import Api from '../lib/request'
import { itemList } from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import _ from 'underscore'


const getMeDetail = () => {
  return new Promise((resolve, reject) => {
    Api.get(COOKIECONSTANT.REQUEST_HOST, {
        headers: {
          'X-Host': 'mall.user.info.get',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        }
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const getUserPageData = () => {
  return new Promise((resolve, reject) => {
    Api.get(COOKIECONSTANT.REQUEST_HOST, {
        headers: {
          'X-Host': 'mall.user.page.data',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
        }
      })
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data.data)
      }, (e) => {
        reject(e)
      })
  })
}
const updateUserInfo = (payload) => {
  const requestData = JSON.stringify(payload)
  return new Promise((resolve, reject) => {
    Api.post(COOKIECONSTANT.REQUEST_HOST, requestData, {
        headers: {
          'Content-Type': 'application/json',
          'X-Host': 'mall.user.update',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
          }
        }
      )
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data)
      }, (e) => {
        reject(e)
      })
  })
}
const sendFeedback = (payload) => {
  const requestData = JSON.stringify(payload)

  return new Promise((resolve, reject) => {
    Api.post(COOKIECONSTANT.REQUEST_HOST, requestData, {
        headers: {
          'Content-Type': 'application/json',
          'X-Host': 'mall.cfg.user.feedback',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
          }
        }
      )
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data)
      }, (e) => {
        reject(e)
      })
  })
}
const uploadHeadIcon = (payload) => {
  return new Promise((resolve, reject) => {
    Api.post(COOKIECONSTANT.REQUEST_HOST, payload, {
        headers: {
          'X-Host': 'mall.img.upload',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN) || ''
          }
        }
      )
      .then((data) => {
        if(data.status != 0) {
          return reject(data.msg)
        }
        resolve(data)
      }, (e) => {
        reject(e)
      })
  })
}

const getNoWatchCount = () => {
  return new Promise((resolve, reject) => {
    // let url = 'https://easy-mock.com/mock/5b7f857ff8ef8d588126af41/sdyxmall/api/ticket-order/no-watch-count'
    // Api.get(url, {
    Api.get(COOKIECONSTANT.REQUEST_HOST, {
      headers: {
        'X-host': 'mall.ticket.order.no-watch-count',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}

const readNoWatchCount = () => {
  return new Promise((resolve, reject) => {
    // let url = 'https://easy-mock.com/mock/5b7f857ff8ef8d588126af41/sdyxmall/api/ticket-order/read-no-watch-msg'
    // Api.get(url, {
    Api.get(COOKIECONSTANT.REQUEST_HOST, {
      headers: {
        'X-host': 'mall.ticket.order.read-no-watch-msg',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data)
    }, e => {
      reject(e)
    })
  })
}
// 账号注销前校验
const cancelAccountCheck = (data) => {
  let query = ''
  if(!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  let url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-host': 'mall.user.cancel-check',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data)
    }, e => {
      reject(e)
    })
  })
}

// 注销 
const cancelAccount = (data) => {

  return new Promise((resolve, reject) => {
    Api.post(COOKIECONSTANT.REQUEST_HOST, JSON.stringify(data), {
      headers: {
        'X-host': 'mall.user.cancel',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data)
    }, e => {
      reject(e)
    })
  })
}
// 查询手机号注册了的平台
const queryPlatform = (data) => {
  let query = ''
  if(!_.isEmpty(data)) {
    query = `?${qs.stringify(data)}`
  }
  let url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        "X-host": "mall.user.registered-platform",
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      },
      noKey: true
    }).then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data)
    }, e => {
      reject(e)
    })
  })
}

export default {
  getMeDetail,
  getUserPageData,
  updateUserInfo,
  sendFeedback,
  uploadHeadIcon,
  getNoWatchCount,
  readNoWatchCount,
  cancelAccountCheck,
  cancelAccount,
  queryPlatform
}
